// extracted by mini-css-extract-plugin
export var callCard = "_pn-0";
export var callMessageButton = "_pn-1";
export var helpIcon = "_pn-3";
export var helpIconContainer = "_pn-4";
export var verticalDivider = "_pn-2";